export default {
  title: "Paladin",
  content: [
    "New ability: Hand of Reckoning: Taunts the target to attack you. 10 sec cooldown.",
    "Seal of the Crusader reworked: now grants each melee attack a chance to cause Holy damage over 15 sec. This effect can stack up to 5 times.",
    "Consecration is now a baseline ability.",
    "Judgement no longer costs mana.",
    "Exorcism and Holy Wrath can now be cast against any target, but always critical hit against Undead and Demon targets.",
    "Judgement of Justice now also caps the target’s movement speed at 100%.",
    "Blessing of Might now also increases ranged attack power.",
  ],
};
